import { Link } from "react-router-dom";
import { formatDiscount, formatPrice } from "../../../../utils/price.utils";
import { getProductPdpUrl } from "../../../../utils/url.utils";

const CartItems = ({ checkoutData }) => {
    return (
        <div className="checkout-right_ck">
            {checkoutData?.data?.items.map((item) => (
                <div className="cart-item" key={item.id}>
                    <div className="item-image">
                        <Link to={getProductPdpUrl(item.product?.action_url, item.product?.sku)} target="_blank" rel="noopener noreferrer">
                            <img
                                className="img-cart-page pointer-crusser"
                                src={item.product.media}
                                alt="product"
                            />
                        </Link>
                    </div>
                    <div className="item-details">
                        <h4 className="item-title pointer-crusser">
                            <Link to={getProductPdpUrl(item.product?.action_url, item.product?.sku)} target="_blank" rel="noopener noreferrer">{item.product?.name}</Link>
                        </h4>
                        <p className="price_details">
                            {formatPrice(item.product.selling_price)}
                            {" "}
                            {item.product.discount > 0 && (
                                <>
                                    <span className="sub-1">
                                        <del>{formatPrice(item.product?.mrp)}</del> &nbsp;
                                        <span className="dis-sub">
                                            {formatDiscount(item.product?.discount)}
                                        </span>
                                    </span>
                                </>
                            )}
                        </p>
                        {item.product?.size === "0 cm" ? null : <p className="item-size">Size : {item.product?.size}</p>}
                        {item.product?.color ? null :
                            <p>
                                Color:{" "}
                                <span className={`color-${item.product.color.toLowerCase()}`}>
                                    {item.product.color}
                                </span>
                            </p>}
                        <p className="item-qtn">
                            Quantity: {item.cart_qty}
                        </p>
                    </div>
                </div>
            ))}
        </div>
    );
};

export default CartItems;
